// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"68bfc1c5","363":"03e8ec4a","391":"72ddd9b9","433":"aae0ecb8","467":"e092c847","488":"c7a6793e","530":"083e2e3f","589":"fdb1b48a","616":"8a5de86e","777":"f19a9177","787":"80bafa43","789":"6e6c24e6","833":"ceb9de51","980":"7bd5c6c5"}[chunkId] + ".chunk.js";
};